module.exports = __webpack_public_path__ + "static/img/postnew.d993d9e2.png";